// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageHeader from 'components/PageHeader/PageHeader'
import HomeImageLinks from 'components/PageHeader/HomeImageLinks'
import Testimonial from 'components/Testimonial/Testimonial'
// import FacebookFeed from 'components/Facebook/FacebookFeed'
import BlogFeed from 'components/Blog/BlogFeed'
import DonateForm from 'views/page/DonateForm'
import LoadScript from 'containers/LoadScript'

// import HomeContent from 'views/home/home-content'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

// Redux:
import { getPageData } from 'actions/page'

class HomeLayout extends React.Component {
	componentDidMount() {
		this.props.getPost( 'home', 'page' )

		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0
	}

	componentDidUpdate() {
		document.title = siteData.site_name
	}

	render() {
		const { location, match, page } = this.props

		return (
			<div>
				<PageHeader match={ match } location={ location } />

				<div className="main-inner">
					<div className="wide-sections">
						<section className="home-image-links on-mobile">
							<HomeImageLinks />
						</section>

						<section className="home-eofy">
							<DonateForm contextType="eofy" />

							{/*<div className="-inner">
								<div>
									<DonateForm contextType="eofy" />
								</div>

								<div>
									<a className="e-widget" href="https://gleam.io/8uV7P/faith-fm-2024-eofy-competition" target="_blank" rel="nofollow">Faith FM EOFY Giveaway</a>

									<LoadScript src="https://widget.gleamjs.io/e.js" />
								</div>
							</div>*/}
						</section>

						{ page && page.banners &&
							<section className="home-banners">
								{ Object.keys( page.banners ).map( key => {
									let item = page.banners[ key ]

									if ( item.link ) {
										return (
											<a className="-banner" href={ item.link } key={ key }>
												<img src={ item.url } alt={ item.alt } />
											</a>
										)
									} else {
										return (
											<div className="-banner" key={ key }>
												<img src={ item.url } alt={ item.alt } />
											</div>
										)
									}
								} ) }
							</section>
						}

						<section>
							<BlogFeed />
						</section>
					</div>
				</div>

				<Testimonial />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber ) => {
			dispatch( getPageData( slug, type, archivePageNumber ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( HomeLayout )
